import Swiper from 'swiper'

export default class {

  constructor(el) {
    this.$el = el;
    console.log(this.$el.className);
    this.swiper = new Swiper(`.${this.$el.className} .swiper-container`, {
      spaceBetween: 15,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/FacebookFeed.js